// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/image/login/ipdc_logo-transparent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/image/login/park_img.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--background-color: #faf9ff;
	--diabled-text-color: #828282;
	--button-text-color: #ffffff;
	--button-backgrond-color: #429d46;
	--forget-text-color: #302cf4;
	--light-black: #333333;
}
* {
	font-family: "Uniform", sans-serif;
	font-style: normal;
}
/* layout */
body {
	display: flexbox;
	place-items: center;
	justify-items: center;
	align-items: center;
	height: 100vh;
	width: 100vh;
	background-color: var(--button-text-color);
}
.ipdc-logo {
	position: absolute;
	float: left;
	left: 24px;
	top: 24px;
	width: 440px;
	height: 185px;
	height: 100%;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
	z-index: 2;
}
.login-container {
	display: flex;
	border-radius: 50px;
	background-color: var(--background-color);
	height: 98vh;
	width: 98vw;
}
.login-left {
	width: 60%;
	height: 100%;
	overflow: hidden;
	background-color: var(--background-color);
	clip-path: polygon(0 0, 100% 0%, 75% 100%, 0% 100%);
	filter: drop-shadow(15px 0px 46px red);
	/*box-shadow: 15px 0px 46px rgba(0, 0, 0, 0.25);  */
	/* filter: drop-shadow(15px 0px 46px rgba(0, 0, 0, 0.25));*/
	/*transform: rotate(12deg);*/
}
.login-left-picture {
	width: 100%;
	height: 100%;
	align-content: end;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});

	background-color: var(--background-color);
}
.login-right {
	display: flexbox;
	padding-top: 10%;
	padding-right: 10%;
	flex-direction: row;
	width: 40%;
	background-color: var(--background-color);
	align-items: center;
	align-content: center;
	vertical-align: middle;
}
.login-title-header {
	/* Title header */
	/* Login_title */
	width: 100%;
	height: 50px;
	font-weight: bold;
	text-align: center;
	font-size: 2rem;
	color: var(--light-black);
	padding-bottom: 0;
	margin-bottom: 0;
}
/* title_Line */
.title-line {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 0;
	border: 3px solid var(--button-backgrond-color);
	margin-bottom: 40px;
	margin-left: 42%;
}

/* username input */
.username-input {
	width: 100%;
	font-weight: 35px;
	line-height: 30px;
	background-color: var(--background-color);
	box-sizing: border-box;
	border: none;
	border-bottom: 2px solid var(--diabled-text-color);
	margin-bottom: 10px;
	text-transform: none;
}
.forget-password {
	/* Forgot Password? */
	width: 100%;
	font-style: italic;
	font-weight: lighter;
	font-size: 16px;
	margin-bottom: 40px;
    margin-left: 10px;
}
.login-button {
	/* button */
	width: 100%;
	height: 50px;
	vertical-align: middle;
	background: var(--button-backgrond-color);
	border-radius: 70px;
	font-weight: bold;
	font-size: 2rem;
	line-height: 40px;
	color: var(--button-text-color);
	cursor: pointer;
	z-index: 100;
}

/* Media Queries for smaller screens */
@media (max-width: 768px) {
	.login-left {
		display: none; /* Hide left section on small screens */
	}

	.login-right {
		width: 100%; /* Expand right section to fill screen */
        height: 100%;
		padding-left: 10%;
		padding-right: 10%;
		margin: 0;
		bottom: 5%;
	}

	.ipdc-logo {
		position: absolute;
		margin-bottom: 20px; /* Add space between logo and content */
		left: 50%;
		transform: translateX(-50%);
		height: fit-content;
	}
}
@media (max-height: 500px) {
	.login-left {
		display: none; /* Hide left section on small screens */
	}

	.login-right {
		width: 100%; /* Expand right section to fill screen */
		padding-left: 10%;
		padding-right: 10%;
        border-radius: 48px;
    }
    .login-container{
        display: block;
        width: 90%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .login-button{
        margin-bottom: 20%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/LoginPage.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;CAC3B,6BAA6B;CAC7B,4BAA4B;CAC5B,iCAAiC;CACjC,4BAA4B;CAC5B,sBAAsB;AACvB;AACA;CACC,kCAAkC;CAClC,kBAAkB;AACnB;AACA,WAAW;AACX;CACC,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,0CAA0C;AAC3C;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,SAAS;CACT,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,6DAA+E;CAC/E,UAAU;AACX;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,yCAAyC;CACzC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,UAAU;CACV,YAAY;CACZ,gBAAgB;CAChB,yCAAyC;CACzC,mDAAmD;CACnD,sCAAsC;CACtC,mDAAmD;CACnD,2DAA2D;CAC3D,4BAA4B;AAC7B;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mDAAwD;;CAExD,yCAAyC;AAC1C;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,UAAU;CACV,yCAAyC;CACzC,mBAAmB;CACnB,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;AACjB;AACA,eAAe;AACf;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,SAAS;CACT,+CAA+C;CAC/C,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA,mBAAmB;AACnB;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,yCAAyC;CACzC,sBAAsB;CACtB,YAAY;CACZ,kDAAkD;CAClD,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,mBAAmB;IAChB,iBAAiB;AACrB;AACA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,yCAAyC;CACzC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,+BAA+B;CAC/B,eAAe;CACf,YAAY;AACb;;AAEA,sCAAsC;AACtC;CACC;EACC,aAAa,EAAE,uCAAuC;CACvD;;CAEA;EACC,WAAW,EAAE,wCAAwC;QAC/C,YAAY;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;CACX;;CAEA;EACC,kBAAkB;EAClB,mBAAmB,EAAE,uCAAuC;EAC5D,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;CACpB;AACD;AACA;CACC;EACC,aAAa,EAAE,uCAAuC;CACvD;;CAEA;EACC,WAAW,EAAE,wCAAwC;EACrD,iBAAiB;EACjB,kBAAkB;QACZ,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[":root {\r\n\t--background-color: #faf9ff;\r\n\t--diabled-text-color: #828282;\r\n\t--button-text-color: #ffffff;\r\n\t--button-backgrond-color: #429d46;\r\n\t--forget-text-color: #302cf4;\r\n\t--light-black: #333333;\r\n}\r\n* {\r\n\tfont-family: \"Uniform\", sans-serif;\r\n\tfont-style: normal;\r\n}\r\n/* layout */\r\nbody {\r\n\tdisplay: flexbox;\r\n\tplace-items: center;\r\n\tjustify-items: center;\r\n\talign-items: center;\r\n\theight: 100vh;\r\n\twidth: 100vh;\r\n\tbackground-color: var(--button-text-color);\r\n}\r\n.ipdc-logo {\r\n\tposition: absolute;\r\n\tfloat: left;\r\n\tleft: 24px;\r\n\ttop: 24px;\r\n\twidth: 440px;\r\n\theight: 185px;\r\n\theight: 100%;\r\n\tbackground: url(\"../../assets/image/login/ipdc_logo-transparent.png\") no-repeat;\r\n\tz-index: 2;\r\n}\r\n.login-container {\r\n\tdisplay: flex;\r\n\tborder-radius: 50px;\r\n\tbackground-color: var(--background-color);\r\n\theight: 98vh;\r\n\twidth: 98vw;\r\n}\r\n.login-left {\r\n\twidth: 60%;\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n\tbackground-color: var(--background-color);\r\n\tclip-path: polygon(0 0, 100% 0%, 75% 100%, 0% 100%);\r\n\tfilter: drop-shadow(15px 0px 46px red);\r\n\t/*box-shadow: 15px 0px 46px rgba(0, 0, 0, 0.25);  */\r\n\t/* filter: drop-shadow(15px 0px 46px rgba(0, 0, 0, 0.25));*/\r\n\t/*transform: rotate(12deg);*/\r\n}\r\n.login-left-picture {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\talign-content: end;\r\n\tbackground: url(\"../../assets/image/login/park_img.jpg\");\r\n\r\n\tbackground-color: var(--background-color);\r\n}\r\n.login-right {\r\n\tdisplay: flexbox;\r\n\tpadding-top: 10%;\r\n\tpadding-right: 10%;\r\n\tflex-direction: row;\r\n\twidth: 40%;\r\n\tbackground-color: var(--background-color);\r\n\talign-items: center;\r\n\talign-content: center;\r\n\tvertical-align: middle;\r\n}\r\n.login-title-header {\r\n\t/* Title header */\r\n\t/* Login_title */\r\n\twidth: 100%;\r\n\theight: 50px;\r\n\tfont-weight: bold;\r\n\ttext-align: center;\r\n\tfont-size: 2rem;\r\n\tcolor: var(--light-black);\r\n\tpadding-bottom: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n/* title_Line */\r\n.title-line {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\twidth: 50px;\r\n\theight: 0;\r\n\tborder: 3px solid var(--button-backgrond-color);\r\n\tmargin-bottom: 40px;\r\n\tmargin-left: 42%;\r\n}\r\n\r\n/* username input */\r\n.username-input {\r\n\twidth: 100%;\r\n\tfont-weight: 35px;\r\n\tline-height: 30px;\r\n\tbackground-color: var(--background-color);\r\n\tbox-sizing: border-box;\r\n\tborder: none;\r\n\tborder-bottom: 2px solid var(--diabled-text-color);\r\n\tmargin-bottom: 10px;\r\n\ttext-transform: none;\r\n}\r\n.forget-password {\r\n\t/* Forgot Password? */\r\n\twidth: 100%;\r\n\tfont-style: italic;\r\n\tfont-weight: lighter;\r\n\tfont-size: 16px;\r\n\tmargin-bottom: 40px;\r\n    margin-left: 10px;\r\n}\r\n.login-button {\r\n\t/* button */\r\n\twidth: 100%;\r\n\theight: 50px;\r\n\tvertical-align: middle;\r\n\tbackground: var(--button-backgrond-color);\r\n\tborder-radius: 70px;\r\n\tfont-weight: bold;\r\n\tfont-size: 2rem;\r\n\tline-height: 40px;\r\n\tcolor: var(--button-text-color);\r\n\tcursor: pointer;\r\n\tz-index: 100;\r\n}\r\n\r\n/* Media Queries for smaller screens */\r\n@media (max-width: 768px) {\r\n\t.login-left {\r\n\t\tdisplay: none; /* Hide left section on small screens */\r\n\t}\r\n\r\n\t.login-right {\r\n\t\twidth: 100%; /* Expand right section to fill screen */\r\n        height: 100%;\r\n\t\tpadding-left: 10%;\r\n\t\tpadding-right: 10%;\r\n\t\tmargin: 0;\r\n\t\tbottom: 5%;\r\n\t}\r\n\r\n\t.ipdc-logo {\r\n\t\tposition: absolute;\r\n\t\tmargin-bottom: 20px; /* Add space between logo and content */\r\n\t\tleft: 50%;\r\n\t\ttransform: translateX(-50%);\r\n\t\theight: fit-content;\r\n\t}\r\n}\r\n@media (max-height: 500px) {\r\n\t.login-left {\r\n\t\tdisplay: none; /* Hide left section on small screens */\r\n\t}\r\n\r\n\t.login-right {\r\n\t\twidth: 100%; /* Expand right section to fill screen */\r\n\t\tpadding-left: 10%;\r\n\t\tpadding-right: 10%;\r\n        border-radius: 48px;\r\n    }\r\n    .login-container{\r\n        display: block;\r\n        width: 90%;\r\n        height: 100%;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n    .login-button{\r\n        margin-bottom: 20%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
